import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { LumynBadge } from '../components/common/LumynBadge';
import { ShieldX, Search } from 'lucide-react';
import { Button } from '../components/ui/button';

export function ForbiddenPage() {
  const { user } = useAuth();
  return (
    <div className="flex items-center justify-center min-h-[70vh] relative overflow-hidden" data-testid="forbidden-page">
      <div aria-hidden className="page-blob bg-rose-500" />
      <div className="relative z-10 text-center space-y-5 max-w-md px-6 animate-fade-in-up">
        <span className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-rose-500/10 ring-1 ring-rose-500/30">
          <ShieldX className="w-8 h-8 text-rose-500" />
        </span>
        <div className="space-y-2">
          <p className="text-[11px] uppercase tracking-[0.18em] text-rose-500 font-semibold">{'403 · Access denied'}</p>
          <h1 className="font-display text-4xl font-bold tracking-tight">{"You're not on the list"}</h1>
          <p className="text-sm text-muted-foreground">{'This page is reserved for a different role. If you think this is a mistake, ask your org admin to bump your access.'}</p>
        </div>
        {user && <LumynBadge variant={user.role} type="role" />}
        <div className="pt-2">
          <Button asChild data-testid="forbidden-home-btn"><Link to="/">{'Return to dashboard'}</Link></Button>
        </div>
      </div>
    </div>
  );
}

export function NotFoundPage() {
  return (
    <div className="flex items-center justify-center min-h-[70vh] relative overflow-hidden" data-testid="not-found-page">
      <div aria-hidden className="page-blob bg-[var(--lumyn-brand)]" />
      <div className="relative z-10 text-center space-y-5 max-w-md px-6 animate-fade-in-up">
        <span className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-[var(--lumyn-brand)]/10 ring-1 ring-[var(--lumyn-brand)]/30">
          <Search className="w-8 h-8 text-[var(--lumyn-brand)]" />
        </span>
        <div className="space-y-2">
          <p className="text-[11px] uppercase tracking-[0.18em] text-[var(--lumyn-brand)] font-semibold">{'404 · Not found'}</p>
          <h1 className="font-display text-4xl font-bold tracking-tight">{'Lost your way?'}</h1>
          <p className="text-sm text-muted-foreground">{"The page you're looking for doesn't exist — or it moved. Let's get you back on track."}</p>
        </div>
        <div className="pt-2">
          <Button asChild data-testid="notfound-home-btn"><Link to="/">{'Return to dashboard'}</Link></Button>
        </div>
      </div>
    </div>
  );
}
